// extracted by mini-css-extract-plugin
module.exports = {"noMargin":"style_noMargin__1JvEK"};